import NfcCardSummary from './NfcCardSummary';

export default NfcCardSummary;
